import styled from 'styled-components';

interface ButtonWrapperProps {
  active?: boolean;
}

export const ButtonWrapper = styled('div')<ButtonWrapperProps>`
  background: ${({ theme, active }) => active && theme.color.whiteRGBA(0.05)};
  border-radius: ${({ theme }) => theme.x2spacePx}px;
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  > button {
    border-radius: ${({ theme }) => theme.x2spacePx}px;
  }
  span {
    color: ${({ theme }) => theme.color.white};
  }
`;
